var React = require('react');

function IgIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("path",{"d":"M15.5,3h-7A5.5,5.5,0,0,0,3,8.5v7A5.5,5.5,0,0,0,8.5,21h7A5.5,5.5,0,0,0,21,15.5v-7A5.5,5.5,0,0,0,15.5,3Zm4,12.5a4.00454,4.00454,0,0,1-4,4h-7a4.00454,4.00454,0,0,1-4-4v-7a4.0045,4.0045,0,0,1,4-4h7a4.0045,4.0045,0,0,1,4,4Z","key":1}),React.createElement("path",{"d":"M12,7.5A4.5,4.5,0,1,0,16.5,12,4.5,4.5,0,0,0,12,7.5ZM12,15a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,12,15Z","key":2}),React.createElement("circle",{"cx":"16.70001","cy":"7.29999","r":"1","key":3})]);
}

IgIcon.defaultProps = {"data-name":"Layer 21","height":"24","id":"Layer_21","viewBox":"0 0 24 24","width":"24"};

module.exports = IgIcon;

IgIcon.default = IgIcon;
